import { largeTabletMax } from '@propertypal/shared/src/constants/mediaQueries';
import { MAX_WIDTH } from '@propertypal/web-ui/src/layout/PageWrapper.style';
import styled from 'styled-components';

const X_PADDING = 30;
const X_PADDING_MOB = 15;

export const Container = styled.div`
  width: 100%;
  background-color: ${(props) => props.theme.backgroundLightest};
  padding: 10px ${X_PADDING}px;
  max-width: ${MAX_WIDTH - X_PADDING * 2}px;
  margin: 0 auto;

  @media (${largeTabletMax}) {
    padding: 10px ${X_PADDING_MOB}px;
    max-width: ${MAX_WIDTH - X_PADDING_MOB * 2}px;
  }
`;

export const Content = styled.div`
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  width: 100%;
  max-width: ${MAX_WIDTH - 60}px;
  align-items: center;
`;
